import IconRound from 'assets/logos/icon-round.svg?react';
import { colors } from 'design';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

export type LogoProps = {
  size?: 'default' | 'large';
};

const useStyle = createUseStyles({
  /*
   * A real `button`, not an `svg` with an `onClick`. This navigates home, so it
   * is a control: it needs a role, an accessible name and keyboard focus, none
   * of which a bare inline SVG has. It used to be an antd `Image` with
   * `alt="logo"`, which at least gave it a name — replacing that with the new
   * brand icon quietly turned it into a click target no keyboard or screen
   * reader could reach.
   *
   * The chrome is stripped so it stays visually identical to the plain SVG.
   */
  logoButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    display: 'inline-flex',
    cursor: 'pointer',
  },
});

const Logo: React.FC<LogoProps> = ({ size = 'default' }) => {
  const navigate = useNavigate();
  const styles = useStyle();

  const goToHome = () => navigate(routes.home.route);

  const dimensions = () => {
    switch (size) {
      case 'large':
        return 100;

      case 'default':
      default:
        return 50;
    }
  };

  return (
    <button type="button" aria-label="Gynger" onClick={goToHome} className={styles.logoButton}>
      {/* Decorative: the button already carries the name. */}
      <IconRound aria-hidden fill={colors.brand.accent} height={dimensions()} width={dimensions()} />
    </button>
  );
};

export default Logo;
